import { isEqualByString } from 'utils/predicates/string/simple.util';

import { determineIfAppointmentMoveBlocked } from './determineIfAppointmentMoveBlocked.bl';

const isAppointmentDropInForeignColumn = ({ appointmentPerms, dropStylistId, procedureStylistId }) => {
  if (!appointmentPerms?.isMovePersonalOnly) return false;
  if (dropStylistId == null || dropStylistId === '') return false;

  const ownColumnId = procedureStylistId ?? appointmentPerms.accessStylistId;
  if (ownColumnId == null || ownColumnId === '') return false;

  return !isEqualByString(dropStylistId, ownColumnId);
};

export const determineAppointmentMovePermissionToast = ({ appointmentPerms, procedureStylistId, dropStylistId, includeDropColumn = false }) => {
  if (!appointmentPerms) return null;

  if (appointmentPerms.isMoveBlocked) {
    return { messageKey: 'scheduler.appointmentPermissions.moveNoAccessToast', toastId: 'ap-move-block' };
  }

  if (determineIfAppointmentMoveBlocked({ appointmentPerms, procedureStylistId })) {
    return { messageKey: 'scheduler.appointmentPermissions.moveOwnOnlyToast', toastId: 'ap-move-own-event' };
  }

  if (includeDropColumn && isAppointmentDropInForeignColumn({ appointmentPerms, dropStylistId, procedureStylistId })) {
    return { messageKey: 'scheduler.appointmentPermissions.ownColumnMoveOnly', toastId: 'ap-move-own-col' };
  }

  return null;
};
